module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m5-378b60cf901813683bbbc0ff6464e708.png";